module.exports = __webpack_public_path__ + "img/s1.76435dd2.jpg";